<template>
  <span>{{count}}{{unit}}</span>
</template>
<script>
  export default {
    name: 'TnCountDown',
    props: {
      value: {
        type: Number,
        require: true
      },
      unit: {
        type: String,
        default: 's'
      },
      limit: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        count: 0,
        timer: ''
      };
    },
    watch: {
      count(val) {
        if (val >= this.value) {
          this.$emit('complete');
        }
      },
      value: {
        handler() {
          window.clearTimeout(this.timer);
          this.count = this.limit;
          this.down();
        },
        immediate: true
      }
    },
    methods: {
      down() {
        if (this.count >= this.value) return;
        this.timer = setTimeout(() => {
          this.count++;
          this.down();
        }, 1000);
      }
    }
  };
</script>
